export const isPhotoTombstoned = (photo: { url?: string; deleted?: boolean } | null | undefined): boolean => {
  if (!photo) return false;
  if (photo.deleted === true) return true;
  if (photo.url === '') return true;
  return false;
};

export const isActiveMediaPhoto = (m: { __typename?: 'MediaPhoto' | 'MediaVideo'; photo?: { url?: string; deleted?: boolean } | null }): boolean =>
  m.__typename === 'MediaPhoto' && !isPhotoTombstoned(m.photo);
